(ns app.front.view.not-found
  (:require [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]))


(defn not-found-view []
  (let [tr (<sub [:tr])]
    [:div.cloudpermit-page
     [:div.flex.flex-col-reverse.md:flex-row
      [:div.md:flex-1.md:p-4.lg:p-12.lg:pr-0.flex.flex-col.justify-center
       [:h1.font-medium.text-center.md:text-left.my-4
        (tr [:page-cannot-be-found])]
       [:div.flex.flex-row.my-4.lg:mb-24.justify-center.md:justify-start
        (cc/button {:kind       :primary
                    :href       "/"
                    :class-name "px-4 mr-4"}
                   (tr [:go-to-home]))
        (cc/button {:kind       :primary
                    :href       (tr [:support-link])
                    :class-name "px-4"}
                   (tr [:support-text]))]]
      [:div.md:flex-1.flex.justify-center.items-center.py-4.md:px-4.lg:px-24
       [:div {:class "w-3/5 md:w-full"}
        [:div.cloudpermit--error-page-artwork
         [:img {:src   "/asset/img/cloudpermit-404-bg.png"
                :class "cloudpermit--error-page-artwork-bg"}]
         [:img {:src   "/asset/img/cloudpermit-404-guy.gif"
                :class "cloudpermit--error-page-artwork-guy"}]]]]]]))
